import { LoginForm } from "@/components/login-form";
import { Storage } from "@/services/storage-services";
import { useEffect } from "react";
import { Link,  useNavigate, useSearchParams } from "react-router";
import Logo from "../../assets/logo.png";
const Login = () => {
  const [searchParams] = useSearchParams()
  const next = searchParams.get("next") || "/"
  const token = Storage.getItem("TreasuraAdminUserToken");
  const navigate = useNavigate();

  useEffect(() => {
    if (token && next !== '/') {
      navigate(next);
    }
    else if (token) {
      navigate("/dashboard");
    }
  }, [navigate, token, next]);

  return (
    <div className="flex flex-col  items-center justify-center gap-6 min-h-svh bg-muted ">
      <div className="flex flex-col items-center gap-6">
        <Link to="/">
          <img src={Logo} className="h-8" />
        </Link>
        <LoginForm />
      </div>
    </div>
  );
};

export default Login;
